import type { ILabel } from '@ardoq/yfiles';
import { classes } from '@ardoq/common-helpers';
import { CollapsibleGraphGroup, GraphItem } from '@ardoq/graph';
import { NO_EXPORT_CLASS_NAME } from '@ardoq/global-consts';
import { ensureContrast } from '@ardoq/color-helpers';
import { colors } from '@ardoq/design-tokens';
import { createSvgElement } from '@ardoq/dom-utils';
import { IconName } from '@ardoq/icons';
import { URL_BOX_ICON_CLASS_NAME, URL_ICON_SIZE } from './consts';
import { dataModelId } from 'tabview/graphComponent/graphComponentUtil';
import { getComponentCssColors } from 'utils/modelCssManager/getCssColors';
import { getElementOpacityIfTransparentized } from 'tabview/blockDiagram/view/utils';
import { spriteIconElement } from 'tabview/spriteIconElement';

const renderOpenGroupUrlLabel = (label: ILabel) => {
  const container = createSvgElement('g', {
    class: NO_EXPORT_CLASS_NAME,
  });

  const graphNode = label.tag;
  const group = label.owner?.tag;
  if (
    !(graphNode instanceof GraphItem) ||
    !(group instanceof CollapsibleGraphGroup)
  ) {
    return container;
  }
  const modelId = dataModelId(graphNode);
  const isComponent = graphNode.isComponent();

  const urlRect = createSvgElement('rect', {
    width: `${URL_ICON_SIZE}`,
    height: `${URL_ICON_SIZE}`,
    rx: '6',
    ry: '6',
    class: classes('yfiles-url-box', isComponent && 'component'),
    fill: 'white',
  });
  container.appendChild(urlRect);

  const backgroundColor = 'white';

  const nodeColor =
    getComponentCssColors(modelId, { useAsBackgroundStyle: false })?.fill ??
    colors.grey200;

  const iconColor = ensureContrast(backgroundColor, nodeColor);
  const publicIcon = createSvgElement('g', {
    class: URL_BOX_ICON_CLASS_NAME,
    opacity: String(
      getElementOpacityIfTransparentized(group.isTransparentized)
    ),
  });

  container.appendChild(publicIcon);
  const urlIcon = spriteIconElement(IconName.OPEN_IN_NEW, {
    cx: URL_ICON_SIZE / 2,
    cy: URL_ICON_SIZE / 2,
    size: URL_ICON_SIZE,
    color: iconColor,
  });
  publicIcon.appendChild(urlIcon);
  return container;
};
export { renderOpenGroupUrlLabel };
